// const CryptoJS = require("crypto-js")
import CryptoJS from "crypto-js"
var key = "encryption996gamesdktechnology01";
var iv = "technologystart1";
export default {
    encrypt(text) {
        key = key ? key : "encryption996gamesdktechnology01";
        // key = key ? key : "d52b97d91e74f8f9fdb9aa9cff64deb3";
        iv = iv ? iv : "technologystart1";
        return CryptoJS.AES.encrypt(text, CryptoJS.enc.Utf8.parse(key), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })
    },
    decrypt(text) {
        key = key ? key : "encryption996gamesdktechnology01";
        // key = key ? key : "encryption996gamesdktechnology01";
        iv = iv ? iv : "technologystart1";
        const result = CryptoJS.AES.decrypt(text, CryptoJS.enc.Utf8.parse(key), {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })
        return result.toString(CryptoJS.enc.Utf8)
    }
}
